import { Box, Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import {
  Button,
  FieldLabel,
  FileUploadButton,
  StandardDialog
} from '@roc/ui';
import { useEffect } from 'react';
import {
  AppraisalDetailsV2Store,
  Valuation,
} from 'libs/feature-documents/src/documents/stores/documentForms/appraisalDetailsV2/appraisalDetailsV2Store';
import { CommentsField } from '../appraisalDetailsV2Fields';

export const SendValuationRevisionDialog = observer(
  ({
    store,
    open,
    onClose,
    valuation,
  }: {
    store: AppraisalDetailsV2Store;
    open: boolean;
    onClose: () => void;
    valuation: Valuation;
  }) => {

    const formStore = store.appraisalActionsStore.appraisalActionsFormStore;

    useEffect(() => {
      if (open) {
        store.appraisalActionsStore.reset();
      }
    }, [open]);

    const dialogContent = (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CommentsField fieldName="reason" formStore={formStore} />
        </Grid>
        <Grid item xs={12}>
          <Box>
            <FieldLabel>Revision Form</FieldLabel>
          </Box>
          <FileUploadButton
            formats=".pdf"
            label={
              <Typography>Click here to upload the revision form</Typography>
            }
            onRemove={() => {
              store.appraisalActionsStore.setUploadedFile(null);
            }}
            onUpload={file => store.appraisalActionsStore.setUploadedFile(file)}
            uploadedFile={store.appraisalActionsStore.uploadedFile}
          />
        </Grid>
      </Grid>
    );

    const dialogActions = (
      <>
        <Button
          testId="closeButton"
          variant="outlined"
          color="primary"
          onClick={onClose}
          style={{ marginRight: 8 }}
        >
          CLOSE
        </Button>
        <Button
          testId="submitButton"
          color="primary"
          variant="contained"
          onClick={async () => {
            console.log('Submitting revision with values:', formStore.getFormValues());
            await store.appraisalActionsStore.submitRevision(
              valuation.clientValuationReferenceId
            );
            onClose();
          }}
        >
          SUBMIT
        </Button>
      </>
    );

    return (
      <StandardDialog
        open={open}
        maxWidth="sm"
        title="Send Revision"
        handleClose={onClose}
        dialogContent={dialogContent}
        dialogActions={dialogActions}
      />
    );
  }
);